import React from 'react'
import styled from 'styled-components'

const StepItem = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 45px;
  width: 45px;
  margin: 0 10px; 
`

const StepItemCircled = StepItem.extend`
  border-radius: 50%;
  border: solid 1px #4a90e2;
`

const Container = styled.div`
  cursor: pointer;
  font-family: Source Sans Pro;
  font-size: 25px;
  min-height: 65px;
  height: 65px;
  font-weight: 300;
  color: #4a90e2;
  padding: 20px 0px;
`

const StepCounter = ({currViewIndex, views}) => {
  const renderSteps = () => {
    return (
      <div className="level-item has-text-centered">
        <span style={{marginRight: 20}}>STEP</span>
        {
          views.map((view, i) => {
            if (i === 0 || i === 5 || i === 6 ) return null;
            return i === currViewIndex
              ? <StepItemCircled key={i}>{i}</StepItemCircled>
              : <StepItem key={i}>{i}</StepItem>
          })
        }
      </div>
    )
  }

  const renderConfirmation = () => {
    return (
      <div className="level-item has-text-centered">
        CONFIRM
      </div>
    )
  }

  const renderComplete = () => {
    return (
      <div className="level-item has-text-centered">
        COMPLETE
      </div>
    )
  }

  const currView = views[currViewIndex]

  let renderView = null
  switch(currView) {
    case 'confirmation':
      renderView = renderConfirmation
      break
    case 'complete':
      renderView = renderComplete
      break
    default:
      renderView = renderSteps
      break
  }

  return (
    <Container className="level animated slideInDown">
      {renderView()}
    </Container>
  )
}

export default StepCounter


// WEBPACK FOOTER //
// ./src/components/Shared/StepCounter.js